import { ReactNode } from 'react';

interface ModelViewerAspectRatioFrameProps {
  /** CSS aspect-ratio value. Omitted in auto mode: the frame then fills the
   * available box, so the user sees no cropping constraint. */
  cssValue?: string;
  showGridLines: boolean;
  children: ReactNode;
}

function ModelViewerAspectRatioFrame({
  cssValue,
  showGridLines,
  children
}: ModelViewerAspectRatioFrameProps) {
  return (
    <div className="absolute inset-4">
      <div
        className="absolute inset-0 m-auto max-w-full max-h-full"
        style={cssValue ? { aspectRatio: cssValue } : undefined}
      >
        <div
          className="z-1 absolute inset-0 pointer-events-none"
          style={{ filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.2))' }}
        >
          {/* Corners mark the crop boundary, so they are hidden in auto mode
              (unconstrained frame) — unless grid lines are on, where they
              close off the composition overlay. */}
          {(cssValue || showGridLines) && (
            <div className="absolute inset-0">
              <div className="border-t-2 border-l-2 border-white/50 w-8 h-8 absolute top-0 left-0" />
              <div className="border-t-2 border-r-2 border-white/50 w-8 h-8 absolute top-0 right-0" />
              <div className="border-b-2 border-l-2 border-white/50 w-8 h-8 absolute bottom-0 left-0" />
              <div className="border-b-2 border-r-2 border-white/50 w-8 h-8 absolute bottom-0 right-0" />
            </div>
          )}
          {showGridLines && (
            <div className="absolute inset-0">
              <div className="border-t-2 border-white/50 w-full h-0 absolute top-1/3" />
              <div className="border-b-2 border-white/50 w-full h-0 absolute top-2/3" />
              <div className="border-l-2 border-white/50 w-0 h-full absolute left-1/3" />
              <div className="border-r-2 border-white/50 w-0 h-full absolute left-2/3" />
            </div>
          )}
        </div>
        <div className="absolute inset-0">{children}</div>
      </div>
    </div>
  );
}

export default ModelViewerAspectRatioFrame;
